import {
  FETCHING_RESOURCES_SUCCESS,
  FETCHING_RESOURCES_FAILED,
  FETCHING_RESOURCES,

  ADD_RESOURCE,
  ADD_RESOURCE_FAILED,
  ADD_RESOURCE_SUCCESS,

  DELETE_RESOURCE,
  DELETE_RESOURCES_FAILED,
  DELETE_RESOURCES_SUCCESS,
  FETCH_SINGLE_DOCUMENT,
  FETCH_SINGLE_DOCUMENT_FAILED,
  FETCH_SINGLE_DOCUMENT_SUCCESS,
} from "./types.js";

import { includes } from 'lodash';


export const initialState = {
  fetchingResources: false,
  addingResources: false,
  fetchingSingleResources: false,
  deletingResources: false,
  resourceToDelete: [],
  resources: {
    data: [],
    page: 1,
    total: 0,
  },
};

export const resourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SINGLE_DOCUMENT: return {
      ...state,
      fetchingSingleResource: true
    }
    case FETCH_SINGLE_DOCUMENT_FAILED: return {
      ...state,
      fetchingSingleResource: false
    }
    case FETCH_SINGLE_DOCUMENT_SUCCESS: return {
      ...state,
      fetchingSingleResource: false,
      resources: {
        ...state.resources,
        data: [action.resource, ...state.resources.data]
      }
    }
    case DELETE_RESOURCE: return {
      ...state,
      deletingResources: true,
      resourceToDelete: action.ids
    }
    case DELETE_RESOURCES_FAILED: return {
      ...state,
      deletingResources: false,
      resourceToDelete: []
    }
    case DELETE_RESOURCES_SUCCESS: {
      const ids = action?.ids;
      const updatedResourceList = state?.resources?.data?.filter((resource) => {
        const isDeleted = includes(ids, resource?.resource_id);
        return !isDeleted;
      });
      return {
        ...state,
        deletingResources: false,
        resourceToDelete: [],
        resources: {
          ...state?.resources,
          data: updatedResourceList,
        },
      };

    }

    case FETCHING_RESOURCES:
      return {
        ...state,
        fetchingResources: true,
      };
    case FETCHING_RESOURCES_FAILED:
      return {
        ...state,
        fetchingResources: false,
        resources: {
          data: [],
          page: 1,
          total: 0,
        },
      };
    case FETCHING_RESOURCES_SUCCESS:
      return {
        ...state,
        fetchingResources: false,
        resources: action?.resources,
      };
    case ADD_RESOURCE: return {
      ...state,
      addingResources: true,
    }
    case ADD_RESOURCE_FAILED: return {
      ...state,
      addingResources: false
    }
    case ADD_RESOURCE_SUCCESS: return {
      ...state,
      addingResources: false,
      resources: {
        ...state?.resources,
        data: [action?.document, ...state?.resources?.data]
      }
    }
    default:
      return state;
  }
};
